

























































import {
  defineComponent,
  onMounted,
  watch,
  reactive,
  SetupContext,
} from '@vue/composition-api'

export default defineComponent({
  props: {
    label: { type: String, required: true },
    date: { type: String, required: true, default: '' },
    setKey: { type: String, required: true },
    required: { type: Boolean, required: false },
    widthClassName: { type: String, required: false },
    isNoneDay: { type: Boolean, required: false, default: false },
    propDefaultYear: { type: Number, required: false, default: null },
    propDefaultMonth: { type: Number, required: false, default: null },
    propDefaultDay: { type: Number, required: false, default: null },
    alert: { type: Boolean, required: false },
  },
  setup(props, context: SetupContext) {
    const currentDate = new Date()
    const maxYear = currentDate.getFullYear() + 25

    const state = reactive({
      years: Array.from({ length: maxYear - 1899 }, (_, i) => maxYear - i), // 1900年〜現在
      months: Array.from({ length: 12 }, (_, i) => i + 1), // 1〜12
      days: [] as number[],
      selectedYear: '',
      selectedMonth: '',
      selectedDay: '',
      defaultYear: props.propDefaultYear || currentDate.getFullYear(),
      defaultMonth: props.propDefaultMonth || currentDate.getMonth() + 1,
      defaultDay: props.propDefaultDay || currentDate.getDate(),
      maxYear,
    })

    // 値を更新してemit
    const updateValue = () => {
      let date
      if (props.isNoneDay) {
        if (!state.selectedYear || !state.selectedMonth) return
        date = new Date(
          Number(state.selectedYear),
          Number(state.selectedMonth) - 1,
          1
        )
      } else {
        if (!state.selectedYear || !state.selectedMonth || !state.selectedDay)
          return
        date = new Date(
          Number(state.selectedYear),
          Number(state.selectedMonth) - 1,
          Number(state.selectedDay)
        )
      }
      context.emit('input-value', date, props.setKey)
    }

    // 日数更新関数
    const updateDays = () => {
      if (state.selectedYear && state.selectedMonth) {
        const daysInMonth = new Date(
          Number(state.selectedYear),
          Number(state.selectedMonth),
          0
        ).getDate()
        state.days = Array.from({ length: daysInMonth }, (_, i) => i + 1)

        // 選択した日が新しい日数範囲を超えた場合、リセット
        if (Number(state.selectedDay) > daysInMonth) {
          state.selectedDay = String(daysInMonth)
        }
      } else {
        state.days = []
      }
      updateValue()
    }

    // 初期値設定
    onMounted(() => {
      context.root.$nextTick(() => {
        if (props.date !== '') {
          const [year, month, day] = props.date.split('-')
          state.selectedYear = year
          state.selectedMonth = month
          state.selectedDay = day
          updateDays()
        }
      })
    })

    // 年月の変更を監視し、日数を更新
    watch(() => [state.selectedYear, state.selectedMonth], updateDays)

    // 初期値をセット
    const handleSetDefault = () => {
      if (!state.selectedYear) {
        state.selectedYear = String(state.defaultYear)
      }
      if (!state.selectedMonth) {
        state.selectedMonth = String(state.defaultMonth)
      }
      if (!state.selectedDay && !props.isNoneDay) {
        state.selectedDay = String(state.defaultDay)
      }
    }

    return {
      state,
      updateDays,
      updateValue,
      handleSetDefault,
      props,
    }
  },
})
